<template>
  <div>
    <span v-if="language == 'slovakia'">
      <terms-slovakia />
    </span>
    <span v-else-if="language == 'czech'">
      <terms-czech />
    </span>
    <span v-else>
      <terms-english />
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TermsCzech from "./TermsCzech.vue";
import TermsEnglish from "./TermsEnglish.vue";
import TermsSlovakia from "./TermsSlovakia.vue";

export default {
  computed: mapGetters(["language"]),
  components: {
    TermsSlovakia,
    TermsCzech,
    TermsEnglish,
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/mobiscope/Terms.vue